// colors.js
const themeColors = [
  {
    title: "Red",
    light: { hex: "#E50914", rgb: "229, 9, 20" }, // "Netflix Red"
    dark: { hex: "#870014", rgb: "135, 0, 20" },
  },
  {
    title: "Orange",
    light: { hex: "#D23C00", rgb: "210, 60, 0" },
    dark: { hex: "#822800", rgb: "130, 40, 0" },
  },
  {
    title: "Yellow",
    light: { hex: "#F59600", rgb: "245, 150, 0" },
    dark: { hex: "#A55F00", rgb: "165, 95, 0" },
  },
  {
    title: "Green",
    light: { hex: "#007864", rgb: "0, 120, 100" },
    dark: { hex: "#003737", rgb: "0, 55, 55" },
  },
  {
    title: "Blue",
    light: { hex: "#005FE6", rgb: "0, 95, 230" },
    dark: { hex: "#141E82", rgb: "20, 30, 130" },
  },
  {
    title: "Pink",
    light: { hex: "#B4145F", rgb: "180, 20, 95" },
    dark: { hex: "#5A003C", rgb: "90, 0, 60" },
  },
  {
    title: "Purple",
    light: { hex: "#78289B", rgb: "120, 40, 155" },
    dark: { hex: "#410064", rgb: "65, 0, 100" },
  },
  {
    title: "Red",
    light: { hex: "#E50914", rgb: "229, 9, 20" }, // "Netflix Red"
    dark: { hex: "#870014", rgb: "135, 0, 20" },
  },
  {
    title: "Orange",
    light: { hex: "#D23C00", rgb: "210, 60, 0" },
    dark: { hex: "#822800", rgb: "130, 40, 0" },
  },
  {
    title: "Yellow",
    light: { hex: "#F59600", rgb: "245, 150, 0" },
    dark: { hex: "#A55F00", rgb: "165, 95, 0" },
  },
];

export default themeColors;
